import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  Optional,
  Renderer2,
  Self,
  SimpleChanges,
} from '@angular/core';
import { NgControl } from '@angular/forms';

import createTextMaskInputElement from 'text-mask-core/src/createTextMaskInputElement';

import { InputComponent } from '../input/input.component';

export interface TextMaskConfig {
  mask: Array<string | RegExp> | Function;
  guide?: boolean;
  placeholderChar?: string;
  keepCharPositions?: boolean;
  pipe?: Function;
  showMask?: boolean;
}

class TextMaskInputElement {
  public update: (value: string) => void;
}

@Component({
  selector: 'rt-masked-input',
  templateUrl: '../input/input.component.html',
  styleUrls: ['../input/input.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaskedInputComponent extends InputComponent {
  @Input()
  public textMaskConfig: TextMaskConfig = {
    mask: [],
    guide: true,
    placeholderChar: '_',
    keepCharPositions: false,
    pipe: undefined,
    showMask: false,
  };

  private textMaskInputElement: TextMaskInputElement;
  private inputElement: HTMLInputElement;

  constructor(
    elementRef: ElementRef,
    renderer2: Renderer2,
    @Optional()
    @Self()
    ngControl: NgControl,
    cdRef: ChangeDetectorRef,
    @Inject(ElementRef) private element: ElementRef,
  ) {
    super(elementRef, renderer2, ngControl, cdRef);
  }

  public ngAfterViewInit(): void {
    if (!this.inputElement && this.input && this.input.nativeElement) {
      this.inputElement = this.input.nativeElement;
      this.setupMask();
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (this.textMaskInputElement !== undefined && changes.value) {
      this.textMaskInputElement.update(this.value!);
    }
  }

  public setValue(value: string): void {
    this.setupMask();
    if (this.inputElement) {
      if (this.textMaskInputElement !== undefined) {
        this.textMaskInputElement.update(value);
      } else {
        // set the initial value for cases where the mask is disabled
        const normalizedValue = value == null ? '' : value;
        this.renderer2.setProperty(this.inputElement, 'value', normalizedValue);
      }
    }
  }

  public handleChange(value: string): void {
    let newValue = value;

    this.setupMask();
    if (this.inputElement && this.textMaskInputElement !== undefined) {
      this.textMaskInputElement.update(value);
      // get the updated value
      newValue = this.inputElement.value;
    }
    //  emit change with updated value
    super.handleChange(newValue);
  }

  private setupMask(): void {
    if (this.inputElement) {
      this.textMaskInputElement = createTextMaskInputElement({
        inputElement: this.inputElement,
        ...this.textMaskConfig,
      });
    }
  }
}
